<template>
  <div id="xy_anima"></div>
</template>

<script>
import lottie from "lottie-web";

export default {
  name: "xy_anima",
  data() {
    return {};
  },
  methods: {
    /**动画初始化 */
    init_anim() {
      //标题动画
      lottie.loadAnimation({
        container: document.getElementById("xy_anima"),
        renderer: "svg", // 渲染方式:svg、canvas
        loop: true, //循环播放，默认：false
        autoplay: true, //自动播放 ，默认true
        path: "/xuyuan/data.json",
      });
    },
  },
  mounted() {
    this.init_anim();
  },
};
</script>

<style scoped></style>
<style>
#xy_anima svg {
  display: block;
}
</style>
